import { Component, EventListener, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

enum States {
	NotEmptyTextArea = 'state-a-text-area--has-value',
}

enum Selectors {
	TextArea = '.js-a-text-area__input',
	HiddenDiv = '.js-a-text-area__hidden-div',
}

@Component('TextArea')
export class TextArea extends GondelJqueryComponent {
	public sync() {
		this.toggleInputNotEmptyClass(this.$ctx.find(Selectors.TextArea));
		$(Selectors.TextArea, this.$ctx).one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}

	@EventListener('input', Selectors.TextArea)
	private _handleTextAreaChange(ev: JQuery.ChangeEvent<HTMLElement, any, HTMLTextAreaElement>) {
		const $textArea = $(ev.target!);
		$textArea.css('height', `${this.getTextareaHeight()}px`);

		this.toggleInputNotEmptyClass($textArea);
	}

	private toggleInputNotEmptyClass($textArea: JQuery) {
		if ($textArea.val() !== '') {
			$textArea.addClass(States.NotEmptyTextArea);
		} else {
			$textArea.removeClass(States.NotEmptyTextArea);
		}
	}

	private getTextareaHeight() {
		const hiddenDiv = this.$ctx.find(Selectors.HiddenDiv).first();
		const $textArea = this.$ctx.find(Selectors.TextArea);
		const cssProperties = $textArea.css([
			'font-family',
			'font-size',
			'line-height',
			'padding-left',
			'padding-right',
			'padding',
		]);
		$.each(cssProperties, (property, value) => {
			hiddenDiv.css(property.toString(), value);
		});
		hiddenDiv.css('width', `${$textArea.outerWidth()}px`);

		if ($textArea.attr('wrap') === 'off') {
			hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
		}

		hiddenDiv.text(`${$textArea.val()}\n`);
		const content = hiddenDiv.html().replace(/\n/g, '<br>');
		hiddenDiv.html(content);
		let height = hiddenDiv.height();

		if (typeof height === 'number') {
			height = height + 16;
		}
		return height;
	}
}
